import { Box, Typography, IconButton, Paper, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { QrReader } from "react-qr-reader";
import { useEffect, useContext, useRef, useState } from "react";
import { HeaderContext } from "../../App";
import liff from "@line/liff";

const QRScanPage = () => {
  const navigate = useNavigate();
  const scannedRef = useRef(false);
  const [isLiffReady, setIsLiffReady] = useState(false);
  const [isInClient, setIsInClient] = useState(false);
  const { setTitle, setShowBack } = useContext(HeaderContext);

   useEffect(() => {
    setTitle("ค้นหาสัตว์เลี้ยง");
    setShowBack(true);

    // init LIFF แค่เพื่อ context / login
    liff
      .init({ liffId: "2008932956-9qPtSx0n" })
      .then(() => {
        setIsLiffReady(true);
        const inClient = liff.isInClient();
        setIsInClient(inClient);
        // don't auto-login or auto-start scan — require explicit user gesture
        // (auto-start can cause camera permission prompt to be dismissed)
        // if needed, show login/scan buttons in the UI
      })
      .catch((err) => {
        console.error("LIFF init error:", err);
      });

    return () => {
      setTitle("Bow HIS.");
      setShowBack(false);
    };
  }, []);

  // const initLiff = async () => {
  //   try {
  //     await liff.init({ liffId : "2008932956-9qPtSx0n" });

  //     // if(liff.isInClient() && !liff.isLoggedIn()){
  //     //   liff.login()
  //     // }
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  // Note: do not require LINE login — allow scanning inside LIFF without login

  const handleResult = (text) => {
    if (scannedRef.current) return; // กันยิงซ้ำ
    scannedRef.current = true;

    navigate("/search/word", {
      state: { scannedPetId: text },
    });
  };

  async function startLiffScan() {
    if (!isLiffReady) return;
    if (!isInClient) {
      alert("กรุณาเปิดหน้านี้ในแอป LINE (LIFF)");
      return;
    }
    try {
      const result = await liff.scanCodeV2();
      const value = result?.value;
      if (value && !scannedRef.current) {
        scannedRef.current = true;
        navigate("/search/word", { state: { scannedPetId: value } });
      } else if (!value) {
        alert("ไม่พบ QR");
      }
    } catch (err) {
      console.error("LIFF scan error:", err);
      alert("สแกนไม่สำเร็จ");
    }
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        backgroundColor: "#000",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      {/* Back */}
      <Box sx={{ position: "absolute", top: 10, left: 10, zIndex: 20 }}>
        <IconButton onClick={() => navigate(-1)}>
          <ArrowBackIcon sx={{ color: "#fff", fontSize: 28 }} />
        </IconButton>
      </Box>

      {/* Camera */}
      <Box sx={{ width: "100%", height: "80%", position: "relative" }}>
        {!isInClient && (
          <QrReader
            constraints={{ facingMode: "environment" }}
            onResult={(result) => {
              if (result?.text) {
                handleResult(result.text);
              }
            }}
            videoStyle={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        )}

        {isInClient && (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              color: "#fff",
              textAlign: "center",
            }}
          >
            <Typography fontSize={18} sx={{ mb: 2 }}>
              สแกนคิวอาร์โค้ดผ่าน LINE
            </Typography>
            <Button variant="contained" onClick={startLiffScan}>
              เริ่มสแกนด้วย LINE
            </Button>
          </Box>
        )}

        {/* Frame */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "78%",
            aspectRatio: "1 / 1",
            transform: "translate(-50%, -50%)",
            border: "3px solid rgba(255,255,255,0.9)",
            borderRadius: "16px",
          }}
        />
      </Box>

      {/* Bottom sheet */}
      <Paper
        sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          p: 4,
          borderTopLeftRadius: 24,
          borderTopRightRadius: 24,
        }}
      >
        <Typography fontSize={20} fontWeight={700} textAlign="center">
          คิวอาร์โค้ดของฉัน
        </Typography>

        <Typography
          sx={{
            fontSize: 14,
            mt: 2,
            textAlign: "center",
            color: "text.secondary",
          }}
        >
          *สแกนคิวอาร์โค้ดของ Bow pet ID
        </Typography>
      </Paper>
    </Box>
  );
};

export default QRScanPage;
